/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XdaTranslateDirective } from '../directives/xda-translate.directive';
import { XrxCheckboxComponent } from '../components/controls/xrx-checkbox.component';

@NgModule({
  declarations: [XdaTranslateDirective, XrxCheckboxComponent],
  imports: [CommonModule],
  exports: [XdaTranslateDirective, XrxCheckboxComponent],
})
export class SqdCommonModule {}
